import React from 'react';
import { change } from 'redux-form';
import { FORM_FIELDS_MAP } from '../utils/constants';

const { students: STUDENTS_FIELD_NAME } = FORM_FIELDS_MAP;

/**
 * This component wraps the SelectAllUndo component.
 * It's role is to set data within the form based on actions from SelectAllUndo.
 * */
const formController = (WrappedComponent) => (props) => {
  const {
    formInfo: { name: formName, dispatch, students: formStudents },
    addSectionToForm,
    removeSectionFromForm,
  } = props;

  const addStudentsBatchToForm = (studentsToSelect) => {
    const newFormStudents = formStudents.concat(studentsToSelect);
    dispatch(change(formName, STUDENTS_FIELD_NAME, newFormStudents));

    addSectionToForm();
  };

  const removeStudentsBatchFromForm = (studentsToUnselect) => {
    const studentIdsToUnselect = studentsToUnselect.map((s) => s.id);
    const newFormStudents = formStudents.filter(
      (s) => !studentIdsToUnselect.includes(s.id),
    );
    dispatch(change(formName, STUDENTS_FIELD_NAME, newFormStudents));

    removeSectionFromForm();
  };

  return (
    <WrappedComponent
      {...props}
      onSelectAll={addStudentsBatchToForm}
      onUndo={removeStudentsBatchFromForm}
    />
  );
};

export default formController;
